import { SourceType } from 'module/api/filter/types';
import { filterableFieldType } from 'module/helpers/filter/type-transformers';
import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { useGetAllSignalFieldsQuery } from 'queries/fields';
import { useMemo } from 'react';

export const useSignalCustomFieldsAsFilterableFields = () => {
  const { data: signalFields, isLoading: signalFieldsLoading } =
    useGetAllSignalFieldsQuery();

  return useMemo(
    () => ({
      loading: signalFieldsLoading,
      fields: (signalFields ?? []).map((field) => ({
        ...field,
        type: filterableFieldType(field),
        sourceType: SourceType.Signal,
        customField: true,
        userCreated: true,
      })) as FilterableField[],
    }),
    [signalFields, signalFieldsLoading],
  );
};
